module.exports = __webpack_public_path__ + "img/racine.6e41cb75.jpg";